import {useId} from 'react';

export const useUniqueFieldId = (name: string): string => {
  const id = useId();
  return `${id}:${name}`;
};
